import {
  formatCurrency,
  formatPaymentStatus,
} from '@/features/invoices/formattingUtils.ts';
import {
  Invoice,
  InvoicesPaymentStateType,
} from '@/features/invoices/types.ts';
import i18n from '@/i18n/i18n.ts';
import {
  Avatar,
  Button,
  Card,
  CardField,
  Label,
  PaletteUnion,
  formatCurrencyAmount,
} from '@arsnovasystems/ars-front-lib';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const InvoiceAvatar = () => {
  const theme = useTheme();
  return (
    <Avatar color={theme.palette.neutral.dark}>
      <ReceiptLongRoundedIcon />
    </Avatar>
  );
};
/**
 * The Invoice card component
 *
 * @param props         props of the component
 * @param props.invoice the invoice to display as a card
 * @returns             JSX of the component
 */
export const InvoiceCard = ({ invoice }: { invoice: Invoice }) => {
  const { t } = useTranslation();
  const colorMap: Record<InvoicesPaymentStateType, PaletteUnion> = {
    paid: 'neutral',
    inprogress: 'neutral',
    unpaid: 'error',
  };

  const urlPdf = invoice.urlPdf;
  const amount = `${formatCurrencyAmount(invoice.total)} ${formatCurrency(t, invoice.currency)}`;

  return (
    <Card
      color={colorMap[invoice.paymentState]}
      subtitle={invoice.date}
      title={invoice.invoiceNumber}
      Avatar={<InvoiceAvatar />}
      bold
    >
      <CardField
        label={t('Status')}
        value={formatPaymentStatus(t, invoice.paymentState)}
      />
      <CardField
        label={t('Amount')}
        value={amount}
      />
      <CardField
        label={t('Mean of payment')}
        value={<Label label={t('payment.' + invoice.paymentMode)} />}
      />

      <Button
        disabled={!urlPdf}
        sx={{
          marginTop: 2,
          width: 'fit-content',
          float: 'right',
        }}
        onClick={() => {
          // open url in new tab
          window.open(urlPdf, '_blank');
        }}
      >
        {i18n.t('ik.see')}
      </Button>
    </Card>
  );
};
